module.exports = __webpack_public_path__ + "static/img/logo-excel.1771a05.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo-excel.png
// module id = 0DNd
// module chunks = 18